/* eslint-disable no-unused-vars */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Hleb Serafimovich <hleb.serafimovich@celadon.ae>

import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  loader: false,
  status: false,
  tradeCustomer1: {
    boxes: null,
  },
  tradeCustomer2: {
    date: null,
    boxes: null,
    phoneNumber: null
  },
  error: null,
  isButtonPressed: false,
};

const ArrangeCollectionReducer = createReducer(initialState, {
  [types.ARRANGE_COLLECTION_REQUEST](state, action) {
    return {
      ...state,
    };
  },
  [types.ARRANGE_COLLECTION_START_LOADER](state, action) {
    return {
      ...state,
      loader: true,
    };
  },
  [types.ARRANGE_COLLECTION_STOP_LOADER](state, action) {
    return {
      ...state,
      loader: false,
    };
  },
  [types.ARRANGE_COLLECTION_SET_STATUS](state, action) {
    return {
      ...state,
      status: action.payload,
    };
  },
  [types.SET_FIELD_FOR_TRADE_CUSTOMER_1](state, action) {
    return {
      ...state,
      tradeCustomer1: {
        [action.field]: action.value
      }
    };
  },
  [types.SET_FIELD_FOR_TRADE_CUSTOMER_2](state, action) {
    return {
      ...state,
      tradeCustomer2: {
        ...state.tradeCustomer2,
        [action.field]: action.value
      }
    };
  },
  [types.BOOK_COLLECTION_FOR_TRADE_1](state) {
    return {
      ...state,
    };
  },
  [types.BOOK_COLLECTION_FOR_TRADE_1_SUCCESS](state) {
    return {
      ...state,
      tradeCustomer1: initialState.tradeCustomer1,
    };
  },
  [types.BOOK_COLLECTION_FOR_TRADE_2](state) {
    return {
      ...state,
    };
  },
  [types.BOOK_COLLECTION_FOR_TRADE_2_SUCCESS](state) {
    return {
      ...state,
      tradeCustomer2: initialState.tradeCustomer2,
    };
  },
  [types.VALIDATE_PHONE_NUMBER](state) {
    return {
      ...state,
    };
  },
  [types.VALIDATE_PHONE_NUMBER_FAILED](state, action) {
    return {
      ...state,
      error: action.error,
    };
  },
  [types.RESET_ERROR](state) {
    return {
      ...state,
      error: initialState.error,
    };
  },
  [types.SET_IS_BUTTON_PRESSED](state, action) {
    return {
      ...state,
      isButtonPressed: action.isButtonPressed,
    };
  },
});

export default ArrangeCollectionReducer;
